import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { Sale } from '../types';

export function useSales() {
  return useQuery({
    queryKey: ['sales'],
    queryFn: async () => (await api.get<Sale[]>('/sales')).data,
  });
}
